import './sideInfo.css';

// const ImageForTs = Image as any;

const SideInfo = ({elements, background, noBg,is_bg, bg_color}: {elements: any[], background: string, noBg: number[], is_bg: boolean, bg_color?:string}) => {
    return (
    <div className="side_info" >
        <div className="side_info_bg" style={{backgroundImage: `url(${background})`,
            backgroundPosition: "16px 16px",
            backgroundSize: is_bg?"88px": "auto 60%",
            backgroundRepeat: "no-repeat",
            backgroundColor: bg_color? bg_color:"#fff",
    }} >
        {/* <ImageForTs
            src={background}
            width={140} height={140}
            style={{ objectFit: 'cover' }}
        /> */}
        </div>
        {
            elements.map((element: any) => {
                return (
                    <div className={`side_info_item ${noBg.find((item: number) => item === elements.indexOf(element)) !== undefined ? 'no_bg' : ''}`} key={elements.indexOf(element)}>
                        {
                            element
                        }
                    </div>
                )
            }
            )
        }
    </div>
    )
}

export default SideInfo;